import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Counter } from '@components/Counter';
import { EquipmentReviewCard } from './EquipmentReviewCard';
import type { EquipmentReviewData } from '../types';

type Props = {
  equipmentList: EquipmentReviewData[];
  jobNumber: string;
};

export const EquipmentReviewCardList = ({
  equipmentList,
  jobNumber
}: Props) => {
  const { t } = useTranslation('customerReview');
  const navigate = useNavigate();

  const handleAssetClick = (woDetailGlobalId: string) => {
    navigate(
      `/work/${jobNumber}/calibration?instrument=${encodeURIComponent(
        woDetailGlobalId
      )}`
    );
  };

  if (equipmentList.length === 0) {
    return (
      <Box
        sx={{
          py: 4,
          px: 2,
          textAlign: 'center'
        }}
      >
        <Typography variant="body2" color="text.secondary">
          {t('noEquipment')}
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ mb: 3 }}>
      <Box sx={{ mb: 2 }}>
        <Counter title={t('equipment')} count={equipmentList.length} />
      </Box>
      {equipmentList.map(item => (
        <EquipmentReviewCard
          key={item.woDetailGlobalId ?? item.assetId}
          item={item}
          onAssetClick={handleAssetClick}
        />
      ))}
    </Box>
  );
};
